import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=06b29c2c&scoped=true"
import script from "./Me.vue?vue&type=script&lang=js"
export * from "./Me.vue?vue&type=script&lang=js"
import style0 from "./Me.vue?vue&type=style&index=0&id=06b29c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b29c2c",
  null
  
)

export default component.exports